import p19 from "@/assets/projectRouter/projectFile/p19.pdf";
import p20 from "@/assets/projectRouter/projectFile/p20.pdf";
var projectPath = [p19, p20];
export { projectPath };
